// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.okex.wallet",
    name: "OKX Wallet",
    homepage: "https://www.okx.com/web3",
    image_id: "45f2f08e-fc0c-4d62-3e63-404e72170500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/okx-buy-bitcoin-eth-crypto/id1327268470",
        android: "https://play.google.com/store/apps/details?id=com.okinc.okex.gp",
        mac: "https://www.okx.com/download",
        windows: "https://www.okx.com/download",
        linux: "https://www.okx.com/download",
        chrome: "https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.okex.wallet",
    mobile: {
        native: "okex://main",
        universal: "https://www.okx.com/download",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map